// extracted by mini-css-extract-plugin
module.exports = {"wrapper__header":"PartnerTrackingRecordSection_wrapper__header__lU3vr","wrapper__icon":"PartnerTrackingRecordSection_wrapper__icon__1it6E"};